import { Link } from "react-router-dom";

import { Button } from "@/components/ui/Button";

/**
 * 404 — top-level route, rendered outside <AppShell>. Full-screen centered
 * display with a single focusable "Go home" link so keyboard users have
 * exactly one interactive target (spec §14 a11y).
 */
export default function NotFound() {
  return (
    <main className="grid min-h-screen place-items-center bg-[var(--bg)] p-6 text-[var(--ink)]">
      <div className="flex flex-col items-center gap-3 text-center">
        <h1 className="font-mono text-[72px] font-semibold leading-none tracking-tight tabular-nums">
          404
        </h1>
        <p className="text-[14px] text-[var(--ink-3)]">
          That page doesn&apos;t exist.
        </p>
        <Button asChild variant="secondary" className="mt-3 min-h-[44px] px-4">
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </main>
  );
}
